export const getActualProductQuantityQuery = `
  query getActualProductQuantity($ids: [ID!]!){
          nodes(ids: $ids){
            id
            ... on Product {
              totalInventory
            }
          }
        }
`
